import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PbxSettingsComponent } from "@onsip/web/features/administrators/pbx-settings/pbx-settings.component";
import { AccountAdminGuard } from "../../shared/guards/accountAdminGuard.guard";

const routes: Routes = [
  {
    path: "",
    component: PbxSettingsComponent,
    children: [
      {
        path: "contact",
        loadChildren: () => import("./contact/contact.module").then(m => m.ContactModule),
        data: { title: "Contact" }
      },
      {
        path: "blocked-numbers",
        loadChildren: () =>
          import("./blocked-numbers/blocked-numbers.module").then(m => m.BlockedNumbersModule),
        data: { title: "Blocked numbers" }
      },
      {
        path: "default-caller-id",
        loadChildren: () =>
          import("./default-caller-id/default-caller-id.module").then(m => m.DefaultCallerIdModule),
        data: { title: "Default caller ID" }
      },
      {
        path: "enabled-services",
        runGuardsAndResolvers: "always",
        canActivate: [AccountAdminGuard],
        loadChildren: () =>
          import("./enabled-services/enabled-services.module").then(m => m.EnabledServicesModule),
        data: { title: "Enable services" }
      },
      {
        path: "migrate-sip-domain",
        loadChildren: () =>
          import("./migrate-sip-domain/migrate-sip-domain.module").then(
            m => m.MigrateSipDomainModule
          ),
        data: { title: "Migrate SIP domain" }
      },
      {
        path: "multi-factor-authentication",
        loadComponent: () =>
          import("./multi-factor-authentication/multi-factor-authentication.component").then(
            m => m.MultiFactorAuthenticationComponent
          ),
        data: { title: "Multi-factor authentication" }
      },
      {
        path: "recording-manager",
        loadChildren: () =>
          import("./recording-manager/recording-manager.module").then(
            m => m.RecordingManagerModule
          ),
        data: { title: "Recording manager" }
      },
      {
        path: "storage-service",
        loadChildren: () =>
          import("./storage-service/storage-service.module").then(m => m.StorageServiceModule),
        data: { title: "Storage service" }
      },
      {
        path: "voicemail-manager",
        loadChildren: () =>
          import("./voicemail-manager/voicemail-manager.module").then(
            m => m.VoicemailManagerModule
          ),
        data: { title: "Voicemail manager" }
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class PbxSettingsRoutingModule {}
